import React from "react";

const More = () => (
  <svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="25.5" cy="25.5" r="24.75" stroke="#0098F0" strokeWidth="1.5"/>
<line x1="33.25" y1="25.4492" x2="16.9405" y2="25.4492" stroke="#0098F0" strokeWidth="1.5" strokeLinecap="square"/>
<path d="M29.4113 30.7035L34.8125 25.5L29.4113 20.2965" stroke="#0098F0" strokeWidth="1.5" strokeLinecap="square"/>
</svg>
);

export default More;
